var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"list-container"},[_c('ul',_vm._l((_vm.msgList),function(msg){return _c('li',[_vm._v(_vm._s(msg.message))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }